// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Zreka","boxTitle":"Qualiphy_boxTitle__1yJ6x","box":"Qualiphy_box__ilnY9","toggleWrap":"Qualiphy_toggleWrap__183gj"};